module.exports = __webpack_public_path__ + "img/back-to-school-uponline.e70e753a.png";